import { apiService } from './api';

class ImportService
{
  static async getGroups(): Promise<any[]>
  {
    try
    {
      const response = await apiService.get<any[]>('group/GetGroups?getAllGroups=true');
      return response;
    }
    catch (error)
    {
      console.error('Error fetching groups:', error);
      throw error;
    }
  }

  static async importFromAsana(payload: {
    listAsanaImport: Record<string, string>[];
    LayerIds: string;
    GroupIds: string;
  }): Promise<string[]>
  {
    try
    {
      const response = await apiService.post<string[]>('tool/importfromasana', payload);
      return response;
    }
    catch (error)
    {
      console.error('Error importing from Asana:', error);
      throw error;
    }
  }
}

export default ImportService;
